import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { BrandGear, BrandGearPaginationFilterRequest, UpsertBrandGear } from '@/models/brand-gear.model';
import { PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";

export const getPagedBrandGears = async (input: BrandGearPaginationFilterRequest): Promise<PagedResponseModel<BrandGear>> => {
  return await getReq(createUrl("a/BrandGear/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getBrandGearsLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: BrandGearPaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedBrandGears(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.name
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })      
  );
};

export const getBrandGear = async (id: number): Promise<BaseResponseModel<BrandGear>> => {
  return await getReq(createUrl(`a/BrandGear/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertBrandGear = async (input: UpsertBrandGear): Promise<BaseResponseModel<BrandGear>> => {
  return await postReq(createUrl("a/BrandGear/Upsert"),
    input
  ).then((res: any) => res.data);
};
